exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb-widget ._2U8i5cIC9Dsl_skAfwnNz1{display:none}\n", ""]);

// exports
exports.locals = {
	"hiddenInputContainer": "_2U8i5cIC9Dsl_skAfwnNz1"
};